import { useState, useEffect } from 'react';
import { supabase } from './supabase';

const T = {
  bg:'#06060d',s1:'#0d0c18',s2:'#12111e',s3:'#181628',
  border:'rgba(255,255,255,0.07)',border2:'rgba(255,255,255,0.13)',
  gold:'#d4a853',gold2:'#f0c878',cream:'#f0ead8',
  text2:'#9890b0',text3:'#55506a',teal:'#1a8a76',
  error:'#ff6b6b',rust:'#e74c3c',
};
const inp = (x={}) => ({background:T.s3,border:`1px solid ${T.border2}`,borderRadius:8,padding:'0.5rem 0.75rem',color:T.cream,fontSize:12,outline:'none',fontFamily:'inherit',width:'100%',boxSizing:'border-box',...x});
const Btn = ({children,onClick,gold,small,style={}}) => (<button onClick={onClick} style={{background:gold?`linear-gradient(135deg,${T.gold},${T.gold2})`:T.s3,border:gold?'none':`1px solid ${T.border2}`,borderRadius:8,padding:small?'4px 10px':'0.55rem 1rem',color:gold?T.bg:T.cream,fontSize:small?11:13,fontWeight:gold?700:400,cursor:'pointer',fontFamily:'inherit',...style}}>{children}</button>);

export default function RosterManager({ userId, repType='agent' }) {
  const [roster,setRoster] = useState([]);

  useEffect(() => {
    if (!userId) return;
    supabase.from('talent_roster').select('*, talent:profiles!talent_roster_talent_id_fkey(id,handle,display_name,avatar_url,crafts)').eq('rep_id', userId)
      .then(({ data }) => { if (data) setRoster(data); });
  }, [userId]);
  const [showInvite,setShowInvite] = useState(false);
  const [inviteHandle,setInviteHandle] = useState('');
  const [commission,setCommission] = useState(10);
  const [activeTab,setActiveTab] = useState('roster');
  const [selectedTalent,setSelectedTalent] = useState(null);

  const saveRoster = (list) => { setRoster(list); };

  const invite = async () => {
    if(!inviteHandle.trim()) return;
    const handle = inviteHandle.startsWith('@') ? inviteHandle : '@'+inviteHandle;
    const { data: talent } = await supabase.from('profiles').select('id,handle,display_name').eq('handle', handle).single();
    if (!talent) { alert('Artizan handle not found. Make sure they have an account.'); return; }
    const { data } = await supabase.from('talent_roster').insert({ rep_id: userId, talent_id: talent.id, commission_rate: commission, status: 'pending', rep_type: 'agent' }).select().single();
    if (data) saveRoster([...roster, { ...data, talent }]);
    setInviteHandle(''); setShowInvite(false);
  };

  const remove = (id) => { if(window.confirm('Remove from roster?')) saveRoster(roster.filter(r=>r.id!==id)); };
  const activate = (id) => saveRoster(roster.map(r=>r.id===id?{...r,status:'active',signed_at:new Date().toISOString()}:r));

  const totalEarned = roster.reduce((a,r)=>a+(r.total_earned||0),0);
  const active = roster.filter(r=>r.status==='active').length;

  return (
    <div style={{padding:20,fontFamily:"'DM Sans','Jost',sans-serif"}}>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:20}}>
        {[['Roster Size',roster.length],['Active',active],['Pending',roster.length-active],['Total Commissions','$'+totalEarned.toLocaleString()]].map(([k,v])=>(
          <div key={k} style={{background:T.s2,border:`1px solid ${T.border}`,borderRadius:10,padding:'10px 14px'}}>
            <div style={{fontSize:10,color:T.text3,textTransform:'uppercase',letterSpacing:2}}>{k}</div>
            <div style={{fontSize:18,fontWeight:700,color:T.gold,marginTop:2}}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{display:'flex',gap:0,marginBottom:16,borderBottom:`1px solid ${T.border}`}}>
        {[{id:'roster',label:'My Roster'},{id:'payments',label:'Payments'}].map(t=>(
          <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{background:'none',border:'none',borderBottom:activeTab===t.id?`2px solid ${T.gold}`:'2px solid transparent',color:activeTab===t.id?T.gold:T.text2,padding:'8px 16px',fontSize:12,fontWeight:activeTab===t.id?700:400,cursor:'pointer',fontFamily:'inherit'}}>{t.label}</button>
        ))}
        <div style={{marginLeft:'auto',paddingBottom:8}}><Btn small gold onClick={()=>setShowInvite(!showInvite)}>+ Invite Talent</Btn></div>
      </div>

      {showInvite && (
        <div style={{background:T.s2,border:`1px solid ${T.border2}`,borderRadius:12,padding:16,marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:700,color:T.gold,marginBottom:12}}>Invite Talent to Roster</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr auto auto',gap:10,alignItems:'end'}}>
            <div>
              <div style={{fontSize:10,color:T.text3,textTransform:'uppercase',letterSpacing:2,marginBottom:4}}>Artizan Handle</div>
              <input value={inviteHandle} onChange={e=>setInviteHandle(e.target.value)} style={inp()} placeholder="@handle"/>
            </div>
            <div>
              <div style={{fontSize:10,color:T.text3,textTransform:'uppercase',letterSpacing:2,marginBottom:4}}>Commission %</div>
              <input type="number" value={commission} onChange={e=>setCommission(+e.target.value)} style={{...inp(),width:80}} min={0} max={50}/>
            </div>
            <Btn gold onClick={invite}>Send Invite</Btn>
          </div>
          <div style={{fontSize:10,color:T.text3,marginTop:8}}>Talent must accept before being added to your active roster. Commission rate is disclosed upon invitation.</div>
        </div>
      )}

      {activeTab==='roster' && (
        <div>
          {roster.length===0&&<div style={{textAlign:'center',padding:'3rem',color:T.text3,border:`1px dashed ${T.border2}`,borderRadius:12}}>No talent on roster yet. Invite talent by their Artizan handle.</div>}
          {roster.map(talent=>(
            <div key={talent.id} onClick={()=>setSelectedTalent(selectedTalent?.id===talent.id?null:talent)} style={{background:T.s2,border:`1px solid ${talent.status==='active'?T.border2:T.border}`,borderRadius:12,padding:'12px 16px',marginBottom:10,cursor:'pointer'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div style={{display:'flex',gap:12,alignItems:'center'}}>
                  <div style={{width:38,height:38,borderRadius:'50%',background:T.s3,border:`1px solid ${T.border2}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>👤</div>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.cream}}>{talent.name||talent.handle}</div>
                    <div style={{fontSize:11,color:T.text2}}>{talent.handle} · {talent.commission_rate}% commission</div>
                  </div>
                </div>
                <div style={{display:'flex',gap:6,alignItems:'center'}}>
                  <span style={{background:talent.status==='active'?T.teal+'20':T.gold+'20',color:talent.status==='active'?T.teal:T.gold,border:`1px solid ${talent.status==='active'?T.teal:T.gold}40`,borderRadius:4,padding:'2px 8px',fontSize:10,fontWeight:700,textTransform:'capitalize'}}>{talent.status}</span>
                  {talent.status==='pending'&&<Btn small onClick={(e)=>{e.stopPropagation();activate(talent.id);}}>Activate</Btn>}
                  <Btn small onClick={(e)=>{e.stopPropagation();remove(talent.id);}} style={{color:T.error,borderColor:T.error}}>Remove</Btn>
                </div>
              </div>
              {selectedTalent?.id===talent.id && (
                <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${T.border}`,display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
                  {[['Bookings',talent.bookings||0],['Total Earned','$'+(talent.total_earned||0).toLocaleString()],['Your Commission','$'+((talent.total_earned||0)*(talent.commission_rate/100)).toFixed(2)]].map(([k,v])=>(
                    <div key={k} style={{background:T.s3,borderRadius:8,padding:'8px 10px'}}>
                      <div style={{fontSize:10,color:T.text3,textTransform:'uppercase',letterSpacing:1}}>{k}</div>
                      <div style={{fontSize:16,fontWeight:700,color:T.gold,marginTop:2}}>{v}</div>
                    </div>
                  ))}
                  <div style={{gridColumn:'1/-1',display:'flex',gap:8}}>
                    <Btn small gold>View Profile</Btn>
                    <Btn small>Submit to Casting</Btn>
                    <Btn small>View Auditions</Btn>
                    <Btn small>Message</Btn>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {activeTab==='payments' && (
        <div>
          <div style={{background:'rgba(212,168,83,0.08)',border:`1px solid ${T.gold}30`,borderRadius:10,padding:12,marginBottom:16,fontSize:11,color:T.text2,lineHeight:1.8}}>
            <div style={{fontWeight:700,color:T.gold,marginBottom:4}}>How Payment Splits Work</div>
            <div>Artizan takes 12% first. Your commission comes next. Talent receives the remainder.</div>
            <div style={{marginTop:4}}>Example: $1,000 booking · 10% commission · Artizan: $120 · Your cut: $88 · Talent: $792</div>
          </div>
          <div style={{textAlign:'center',padding:'2rem',color:T.text3,border:`1px dashed ${T.border2}`,borderRadius:12}}>No payment history yet. Payment splits are tracked automatically when bookings are processed.</div>
        </div>
      )}
    </div>
  );
}